module.exports = __webpack_public_path__ + "static/media/doubleShieldGrid.730b5183.jpg";